
import request from '@/shared/apis'

// URL helper functions
const getBaseApiUrl = () => {
  return '';
};

const getEvaluationApiUrl = (evaluationId) => {
  return `${getBaseApiUrl()}/evaluations/${evaluationId}`;
};

const getSectionResponseApiUrl = (evaluationId, sectionResponseId) => {
  return `${getEvaluationApiUrl(evaluationId)}/section-responses/${sectionResponseId}`;
};

const getAperEvaluationApiUrl = (evaluationId) => {
  return `${getBaseApiUrl()}/evaluations/${evaluationId}`;
};

/**
 * Submit a section for evaluation
 * @param evaluationId - The evaluation ID
 * @param sectionResponseId - The section response ID
 * @returns Updated section response with submitted status
 */
export const submitSection = async (
  evaluationId,
  sectionResponseId
) => {
  const response = await request.patch(
    `${getSectionResponseApiUrl(evaluationId, sectionResponseId)}/submit`
  );
  return response.data;
};

/**
 * Mark a section as draft
 * @param evaluationId - The evaluation ID
 * @param sectionResponseId - The section response ID
 * @returns Updated section response with draft status
 */
export const markSectionAsDraft = async (
  evaluationId,
  sectionResponseId
) => {
  const response = await request.patch(
    `${getSectionResponseApiUrl(evaluationId, sectionResponseId)}/draft`
  );
  return response.data;
};

/**
 * Check if a section can be edited
 * @param evaluationId - The evaluation ID
 * @param sectionResponseId - The section response ID
 * @returns Boolean indicating if section can be edited
 */
export const checkSectionCanEdit = async (
  evaluationId,
  sectionResponseId
) => {
  const response = await request.get(
    `${getSectionResponseApiUrl(evaluationId, sectionResponseId)}/can-edit`
  );
  return response.data;
};

/**
 * Get all section responses for an evaluation
 * @param evaluationId - The evaluation ID
 * @returns Array of section responses with status info
 */
export const getSectionResponses = async (
  evaluationId
) => {
  const response = await request.get(
    `${getEvaluationApiUrl(evaluationId)}/section-responses`
  );
  return response.data;
};

/**
 * Check evaluation sections status
 * @param evaluationId - The evaluation ID
 * @returns Evaluation status information
 */
export const getEvaluationSectionsStatus = async (
  evaluationId
) => {
  const response = await request.get(
    `${getAperEvaluationApiUrl(evaluationId)}/sections-status`
  );
  return response.data;
};
